import { Component, OnInit, ViewEncapsulation, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { LoginService } from '../login.service';
import { FlashMessagesService } from 'angular2-flash-messages';
import { Observable } from 'rxjs/Observable';
import { AutosuggestService } from '../autosuggest.service';
import { environment } from '../../environments/environment';

@Component({
  selector: 'app-add-service-list',
  templateUrl: './add-service-list.component.html',
  styleUrls: ['./add-service-list.component.css']
})
export class AddServiceListComponent implements OnInit {
  uploadDir: string = environment.uploadDir;
  @ViewChild('fileInput') fileInput;
  selectedOption: string;
  uploads_name: any = {};
  model: any;
  user: any = {};
  results: any = {};
  currentUser: any = {};
  currentOrg: any;
  sessionData: any = {};
  searching = false;
  searchFailed = false;
  hideSearchingWhenUnsubscribed = new Observable(() => () => this.searching = false);
  certList: any = [];
  certificate: any = {
    cert_details: []
  };
  cert: any = {};
  contId: number;
  mask: any[] = ['(', /[1-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];
  tinmask: any[] = [/[0-9]/, /\d/, '-', /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/];
  certmask: any[] = [/\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/];
  userType: number;
  showLoader: boolean;
  wbe_goal: number;
  mbe_goal: number;
  savecertList: any;
  fieldName: string;
  fileList: FileList;
  certId: any;
  fileU: boolean;
  formedata: FormData;
  onlyview: boolean = false;
  options: any;
  getservicecategory: any;
  formdata: FormData;
  upname: any;
  targetfile: any;
  service_list_id: any;
  headerLabel: string;
  service_category_id: any;
  ProductList: any;
  constructor(
    private router: Router,
    private loginservice: LoginService,
    private Autosuggest: AutosuggestService,
    private _arout: ActivatedRoute,
    private _flashMessagesService: FlashMessagesService

  ) {
    this.uploads_name.inventory_manager_upload_path = {
      file_name: '',
      file_temp_name: '',
    };
    this.model = {
      service_category_id: '0'
    };

    this.currentUser = JSON.parse(this.loginservice.getLocalSession('currentUser'));
    this.loginservice.getservicecategory('', '1', this.currentUser).subscribe(data => {
      this.getservicecategory = data['comp_details'];
    }, error => { alert('Network Error getservicecategory API'); });

  }

  sync() {
    if (confirm('By Clicking Ok. Menu Price Will Be Upadted From Current Price')) {
      if (confirm('Are you sure want to Sync')) {
        // alert(this.service_list_id)
        this.loginservice.SyncMenuPrice(this.service_list_id, this.model, this.currentUser).subscribe(data => {
          this._flashMessagesService.show('synchronization Done Successfully', { cssClass: 'alert-success' });
          this.ngOnInit();
        }, error => { alert('Network Error SyncMenuPrice API'); });
      }
    }
  }

  cdisabl() {
    setTimeout(() => { return true; }, 1000)
  }
  ngOnInit(): void {
    this.model.price_s = 0;
    this.model.price_m = 0;
    this.model.price_l = 0;

    this.model.pre_old_price_s = 0;
    this.model.pre_old_price_m = 0;
    this.model.pre_old_price_l = 0;

    this.model.old_price_s = 0;
    this.model.old_price_m = 0;
    this.model.old_price_l = 0;

    this.model.curr_price_s = 0;
    this.model.curr_price_m = 0;
    this.model.curr_price_l = 0;

    this.loginservice.getProductsMap(this.currentUser).subscribe(data => {
      this.ProductList = data['comp_details'];
      // this.ProductList.forEach(element => {
      //   element.product.forEach(elements => {
      //     elements.checked = true;
      //   });
      // });
      // setTimeout(() => {
      //   this.ProductList.forEach(element => {
      //     element.product.forEach(elements => {
      //       elements.checked = false;
      //     });
      //   });
      // }, 1000);
    }, error => { alert('Network Error getProductsMap API'); });

    // this.showLoader = true;
    this._arout.params.subscribe(p => {
      if (p.view_id) {
        this.onlyview = true;
      }
      if (p.service_list_id) {
        this.headerLabel = 'Edit';
        this.service_list_id = p.service_list_id
        this.getserviceListAddEdit(p.service_list_id);
      } else {
        this.headerLabel = 'New';
      }
    }, error => { alert('Network Error params API'); });
  }

  setCat(n) {
    if (n > 0) {
      this.model.service_category_id = n;
    } else {
      this.model.service_category_id = '';
    }
  }

  getserviceListAddEdit(service_list_id) {
    this.loginservice.getserviceListAddEdit(service_list_id, this.currentUser).subscribe(data => {
      if (data['status'] == 'success') {
        if (service_list_id) {
          this.model = data;
          if (data['file_name'] != '' && data['file_temp_name'] != '') {
            this.uploads_name.inventory_manager_upload_path = {
              file_name: data['file_name'],
              file_temp_name: data['file_temp_name'],
            };
          }
          setTimeout(() => { this.assign_checkbox(data['product_list']); }, 500);
        }
        this.showLoader = false;

      } else {
        this.showLoader = false;
      }

    },
      error => {
        alert('Network Error getserviceListAddEdit API');
        this.showLoader = false;
      });
  }

  assign_checkbox(data) {
    data.forEach((obj) => {
      this.ProductList.forEach((items) => {
        items.product.forEach((item) => {
          if (item['inventory_manager_id'] === obj.inventory_manager_id) {
            item.checked = true;
            item.quantity_s = obj.quantity_s;
            item.quantity_m = obj.quantity_m;
            item.quantity_l = obj.quantity_l;
          }
        });
      });
    });
  }


  saveServiceList() {
    // this.showLoader = true;
    let checkedItems = []
    checkedItems = this.ProductList.flatMap(item =>
      item.product.filter(items => items.checked)
    );

    if (this.model['price_s'] <= 0 && this.model['price_m'] <= 0 && this.model['price_l'] <= 0) {
      this.showLoader = false;
      alert('Price S, M Or L Sholud greater Than Zero');
      return false;
    }

    let ci = 0;
    checkedItems.forEach(element => {
      if (element.quantity_s <= 0 && element.quantity_m <= 0 && element.quantity_l <= 0) {
        ci++
      }
    });

    if (ci > 0) {
      this.showLoader = false;
      alert('Quantity S, M Or L Sholud greater Than Zero');
      return false;
    }


    this.loginservice.saveServiceList(this.model, checkedItems, this.currentUser)
      .subscribe(
        data => {
          if (data['status'] === 'success') {
            this._flashMessagesService.show('Updated Successfully', { cssClass: 'alert-success' });
            this.showLoader = false;

            if (this.targetfile) {
              this.uploadmanager(this.formdata, this.upname, this.service_list_id)
            } else {
              this.router.navigate(['/Servicelist']);
            }
          } else {
            this._flashMessagesService.show(data['message'], { cssClass: 'alert-danger' });
            this.showLoader = false;
          }
        },
        error => {
          alert('Network Error saveServiceList API');
        });
  }

  chekspack(items) {
    if (items.checked) {
      const NormalCategory = items.product.filter(item => !item.checked);
      if (NormalCategory.length > 0) {
        items.product.forEach((element, index) => {
          if (!element.checked) {
            // this.getprice(element, '+')
          }
          element.checked = false;
        });
      }
      items.product.forEach((element, index) => {
        // this.getprice(element, '-')
        element.checked = false;
      });
    } else {
      const NormalCategory = items.product.filter(item => item.checked);
      if (NormalCategory.length > 0) {
        items.product.forEach((element, index) => {
          if (element.checked) {
            // this.getprice(element, '-')
          }
          element.checked = false;
        });
      }
      items.product.forEach((element, index) => {
        element.checked = true;
        // this.getprice(element, '+')
      });
    }
  }


  upload(f, name) {

    if (f.target.files[0]) {
      const formData = new FormData();
      formData.append(name, f.target.files[0]);
      this.formdata = formData;
      this.upname = name;
      this.targetfile = f.target.files[0];
      this.uploads_name.inventory_manager_upload_path = { file_name: f.target.files[0].name };


    }
  }

  uploadmanager(formData, name, service_list_id) {
    this.loginservice.uploadFile1(formData, name, service_list_id, '', 'id', 'inventory_manager').subscribe(r => {
      if (r['status'] === 'success') {
        var path_name = name + '_path';
        this.uploads_name[path_name] = r;
        this.router.navigate(['/inventory-manager']);
      } else {
        this._flashMessagesService.show(r['message'], { cssClass: 'alert-danger' });
        this.router.navigate(['/inventory-manager']);
      }
    },
      error => {
        alert('Network Error uploadmanager API');
        this._flashMessagesService.show('Error in the Data/Server', { cssClass: 'alert-danger' });
        this.router.navigate(['/inventory-manager']);
      });
  }

  clearAll() {
    this.model = {};
  }

  deleteupload(service_list_id) {
    if (confirm('Deleting of this inventory item is done from the entire system')) {
      if (confirm('Are you sure want to delete')) {
        this.loginservice.deleteupload(service_list_id, 'id', 'inventory_manager').subscribe(data => {
          this._flashMessagesService.show('Deleted Successfully', { cssClass: 'alert-success' });
          this.uploads_name.inventory_manager_upload_path = {
            file_name: '',
            file_temp_name: '',
          };
        },
          error => {
            alert('Network Error deleteupload API');
            this.showLoader = false;
          });
      }
    }
  }

  checkDelete(item, event) {
    if (event.target.checked === false) {
      if (confirm('Are Sure Want To Remove this Product')) {
        if (this.service_list_id) {
          let checked = 'checked'
          if (item.hasOwnProperty(checked) && item[checked] === true) {
          } else {
            this.loginservice.checkItemquantity2(item, this.service_list_id, this.currentUser).subscribe(
              data => {
                if (data['status'] === 'fail') {
                  item.checked = true;
                  alert(item.service_desc + " Is Already Used In Billing Can't Able to Uncheck")
                }
              }, error => { alert('Network Error checkItemquantity2 API'); });
          }
        }

      } else {
        event.target.checked = true;
        item.checked = true;
      }
    } else {
      this.loginservice.checkItemquantityExist(item, this.service_list_id, this.currentUser).subscribe(
        data => {
          if (data['status'] == 'dontallow') {
            alert('Product Is Empty')
            event.target.checked = false;
            item.checked = false;
          }
        }, error => { alert('Network Error checkItemquantityExist API'); });

    }
  }
}



// WEBPACK FOOTER //
// ./src/app/add-service-list/add-service-list.component.ts